import { render, staticRenderFns } from "./ChartOrders.vue?vue&type=template&id=c41453cc"
import script from "./ChartOrders.vue?vue&type=script&lang=js"
export * from "./ChartOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports